import React, { Component } from 'react';
import TextBox from '@components/TextBox/TextBox';
import { connect } from 'react-redux';

import PricingRow from './PricingRow/PricingRow';
import TripSummary from './TripSummary/TripSummary';
import MobileNav from '@components/Quoting/MobileNav/MobileNav';
import * as actions from '@store/actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Pricing extends Component {
  state = {
    tooltipOpen: '',
    legInfo: this.props.legInfo
  };
  selectAircraft = aircraft => {
    this.props.setSpecification(this.state.legInfo);
    this.props.selectAircraft(aircraft);

    this.props.nextClick();
  };

  toggleTooltip = tooltip => {
    this.setState({
      tooltipOpen: tooltip === this.state.tooltipOpen ? '' : tooltip
    });
  };

  setSpecifications = (key, index, value) => {
    const legInfo = JSON.parse(JSON.stringify(this.state.legInfo));

    legInfo[key][index] = value;
    this.setState({
      legInfo: legInfo
    });
  };

  render() {
    // E50P - Phenom 100
    // 525B - Phenom 300
    // E35L - L650

    const pricingRows = [];
    const { isMobile } = this.props;

    let i = 0;
    let P100Total = 0;
    let P300Total = 0;
    while (i < this.props.flightInfo.legs_amount) {
      P100Total += this.props.flightInfo['E50P'].legs[i].total;
      P300Total += this.props.flightInfo['525B'].legs[i].total;

      pricingRows.push(
        <PricingRow
          {...this.state}
          toggleTooltip={this.toggleTooltip}
          key={i}
          index={i + 1}
          onSpecificationChange={this.setSpecifications}
          P100={this.props.flightInfo['E50P'].legs[i]}
          P300={this.props.flightInfo['525B'].legs[i]}
          L650={
            this.props.flightInfo['E35L'] === undefined
              ? {}
              : this.props.flightInfo['E35L'].legs[i]
          }
          legInfo={this.state.legInfo[i]}
          isMobile={isMobile}
          p300Only={this.props.flightInfo.p300only}
          contractVersion={this.props.data.profile_ContractVersion}
        />
      );
      i++;
    }

    const pageLabel =
      this.props.data.profile_ContractVersion === 2
        ? 'Trip Information'
        : 'Pricing';
    return (
      <React.Fragment>
        {isMobile && <MobileNav {...this.props} title={pageLabel} />}
        <TextBox header={!isMobile ? pageLabel : false}>
          {pricingRows}
          <TripSummary
            isMobile={isMobile}
            P100Total={P100Total}
            P300Total={P300Total}
            selectAircraft={this.selectAircraft}
            tooltipOpen={this.state.tooltipOpen}
            toggleTooltip={this.toggleTooltip}
            p300Only={this.props.flightInfo.p300only}
            contractVersion={this.props.data.profile_ContractVersion}
          />
        </TextBox>
        {!this.props.isMobile && (
          <button
            className="btn btn-transparent mt-2 float-left"
            onClick={this.props.prevClick}
          >
            <strong>
              <FontAwesomeIcon icon={['fas', 'chevron-left']} />
              &nbsp;&nbsp;Back
            </strong>
          </button>
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    flightInfo: state.flightInfo.data,
    legInfo: state.flightInfo.legInfo
  };
};
const mapDispatchToProps = dispatch => {
  return {
    selectAircraft: aircraft => dispatch(actions.quotingSetAircraft(aircraft)),
    setSpecification: legInfo =>
      dispatch(actions.quotingSetSpecifications(legInfo))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pricing);



// WEBPACK FOOTER //
// ./src/components/Quoting/Board/Pricing/Pricing.jsx